import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { IMAGE_BASE_URL } from "../config";

class CastList extends Component {
  render() {
    const { movies } = this.props;
    console.log(movies);
    return (
      <div className="cast-list">
        {movies.map(each => (
          <div className="cast-item">
            <Link to={`/cast/detail=${each.id}`}>
              {each.profile_path ? (
                <img
                  src={`${IMAGE_BASE_URL}w200${each.profile_path}`}
                  alt="profile"
                />
              ) : (
                <img src="/images/notfound.jpg" alt="profile" />
              )}
              <p>{each.name}</p>
            </Link>
          </div>
        ))}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    movies: state.movies
  };
};

export default connect(mapStateToProps, null)(CastList);
